export default __webpack_public_path__ + "static/media/ditLoginLeftImage2.b5ded151.png";